const louisianaData = {
  louisiana: {
    name: 'Louisiana',
    overview: {
      keyPoints: [
        'Louisiana courts decide custody according to the child’s best interests under Louisiana Civil Code article 131.',
        'Courts may award joint or sole custody. Joint custody is addressed in Louisiana Civil Code article 132.',
        'Custody decisions can consider the child’s relationships, stability, safety, education, and other relevant circumstances.',
        'Louisiana law recognizes a child’s preference as one factor when appropriate; it does not determine the outcome by itself.',
        'Louisiana has limited grandparent visitation provisions, including Louisiana Revised Statutes § 9:344.',
        'Louisiana adopted the UCCJEA, which helps determine which state has authority over custody matters and supports enforcement of custody orders.'
      ],
      uniqueFeatures: [
        'The parent designated as domiciliary parent generally has authority to make decisions affecting the child unless the custody order provides otherwise.',
        'Courts may consider abuse history and other safety concerns when determining custody and visitation.',
        'Louisiana’s UCCJEA provisions are found in Louisiana Revised Statutes § 13:1801 et seq.'
      ]
    },
    legalRequirements: {
      residency: 'Custody jurisdiction generally depends on the UCCJEA and the child’s home-state circumstances. Confirm the applicable requirements with the court or a Louisiana attorney.',
      filing: 'Custody matters are handled in the appropriate Louisiana district court. Filing procedures and forms can vary by parish.',
      paternity: 'When parentage is not legally established, it may need to be established before custody or support rights can be decided.',
      documentation: 'Commonly relevant materials include existing custody or support orders, proposed parenting schedules, school and medical information, and records related to the child’s care and safety.',
      uniqueRules: [
        'Louisiana Civil Code article 131 sets out the best-interests standard for custody decisions.',
        'Louisiana Civil Code article 132 addresses joint custody.',
        'The UCCJEA governs interstate jurisdiction and enforcement questions; it does not replace the need to follow local court procedures.'
      ]
    },
    custodyTypes: {
      physicalCustody: 'Physical custody concerns where the child lives and each parent’s day-to-day care. Louisiana orders may designate a domiciliary parent.',
      legalCustody: 'Legal custody concerns parental authority and decision-making for the child. The details depend on the custody judgment.',
      jointCustody: 'Joint custody allows both parents to share custody responsibilities. The court’s order specifies the allocation of authority and the parenting schedule.',
      visitation: 'A parent’s time with the child is set by the custody judgment or agreement. The schedule should address regular parenting time, holidays, and exchanges.',
      specialProvisions: [
        'Courts may consider the child’s safety, relationships with parents and siblings, and continuity in home, school, and community.',
        'A child’s views may be considered when appropriate, but the child does not make the custody decision.',
        'Grandparent visitation is limited and depends on statutory requirements and the circumstances of the case.'
      ]
    },
    parentingPlans: {
      required: false,
      elements: [
        'Regular parenting schedule, including weekdays, weekends, holidays, and school breaks',
        'Exchange locations, transportation, and responsibility for travel',
        'How parents will share important information about education and healthcare',
        'How parents will communicate about the child and resolve routine disagreements',
        'Provisions for emergencies, schedule changes, and travel'
      ],
      tips: [
        'Use a specific schedule that reflects the child’s school, care, and activity routines.',
        'Keep communications focused on the child and preserve copies of important messages and records.',
        'Review any existing order before making changes; seek legal guidance about modifications.',
        'If there are safety concerns, ask a Louisiana attorney or court resource about appropriate protections.'
      ]
    },
    childSupport: {
      guidelines: 'Louisiana child support is governed by state law and the applicable court guidelines. The custody schedule alone does not determine the amount.',
      factors: [
        'The parents’ income and applicable adjustments',
        'The number of children covered by the support order',
        'Health insurance and qualifying childcare expenses',
        'Other circumstances recognized by Louisiana law and the applicable guidelines'
      ],
      calculation: 'Use current Louisiana court or child-support agency resources for an estimate and confirm the result with the court or a qualified professional.',
      modifications: 'A support order may be subject to modification under Louisiana law when the required circumstances are met.',
      enforcement: 'For payment, enforcement, and case-specific questions, contact Louisiana’s child support agency or the court handling the matter.'
    },
    resources: {
      courts: [
        {
          name: 'Louisiana Legislature — Louisiana Civil Code',
          url: 'https://legis.la.gov/legis/Laws_Toc.aspx?folder=75&level=Parent',
          description: 'Official legislative source for Louisiana Civil Code provisions, including custody articles.'
        },
        {
          name: 'Louisiana Legislature — Revised Statutes',
          url: 'https://legis.la.gov/legis/Laws_Toc.aspx?folder=74&level=Parent',
          description: 'Official source for Louisiana Revised Statutes, including UCCJEA and grandparent-visitation provisions.'
        },
        {
          name: 'Louisiana Supreme Court',
          url: 'https://www.lasc.org/',
          description: 'Official Louisiana Supreme Court website and court information.'
        }
      ],
      support: [
        {
          name: 'Louisiana Department of Children and Family Services — Child Support',
          url: 'https://www.dcfs.louisiana.gov/page/child-support',
          description: 'State child-support program information and services.'
        }
      ],
      legal: [
        {
          name: 'Louisiana State Bar Association',
          url: 'https://www.lsba.org/',
          description: 'Information and resources from the Louisiana State Bar Association.'
        }
      ],
      educational: [
        {
          name: 'FindLaw — Louisiana Law',
          url: 'https://www.findlaw.com/state/louisiana-law.html',
          description: 'FindLaw’s Louisiana law overview. Verify current requirements against statutes and court resources.'
        }
      ]
    },
    bestInterestsFactors: [
      'The child’s relationships with each parent and other significant people in the child’s life',
      'The child’s adjustment and need for stability in home, school, and community',
      'The capacity and willingness of each parent to provide care and meet the child’s needs',
      'The child’s age, needs, and reasonable preference when appropriate',
      'The history of abuse or other safety concerns',
      'The child’s relationships with siblings and other family members',
      'Any other relevant circumstances affecting the child’s welfare'
    ]
  }
};

export default louisianaData;